import { Alert, AlertTitle, Box, Button, Paper, Stack, TextField, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { Link, useParams } from "react-router-dom"
import Loading from "../../components/Loading"
import config from "../../common/Config"

const Verify = () => {
	const {token}									= useParams()

	const [returnObject, setReturnObject]			= useState()
	const [formState, setFormState]					= useState(formFields)

	useEffect(() => {
		if (token) handleValidation()
	}, [])

	const handleFormSubmit = (e) => {
		e.preventDefault()

		formFields.email.error = !e.target.email.validity.valid
		setFormState(formFields)

		if (e.target.checkValidity()) {
			handleRevalidation()
		}
	}

	const handleFormChange = (e) => {		
		setFormState(prevState => ({
			...prevState, 
			[e.target.name] : {
				value : e.target.value
			}
		}))
	}

	const handleValidation = () => {
		fetch(config.apiUrl +"/verify/"+ token)
		.then(result => result.json())
		.then(result => {
			if (result.status === 200) {
				setReturnObject({
					status	: "success",
					message	: <Typography>Usuario validado com sucesso. Clique <Link to="/login">aqui</Link> para efetuar login</Typography>
				})
			}
			else {
				setReturnObject({
					status	: "error",
					message	: <Typography>Erro ao validar usuário. Token inválido, clique <Link to="/verify" reloadDocument>aqui</Link> para gerar o token novamente.</Typography>
				})
			}
		})
	}

	const handleRevalidation = () => {
		fetch(config.apiUrl +"/revalidate/"+ formState.email.value)
		.then(result => result.json())
		.then(result => {
			if (result.status === 200) {
				setReturnObject({
					status	: "success",
					message	: <Typography>Solicitação processada com sucesso, verifique seu e-mail!</Typography>
				})
			}
			else {
				setReturnObject({
					status	: "error",
					message	: <Typography>Ocorreu um erro na sua solicitação.</Typography>
				})
			}
		})
	}

	return (
		<Paper sx={{martinTop:0, martinBottom:4, marginLeft: 2, marginRight: 4, height:'88vh', display: 'flex', justifyContent: 'center' }} elevation={1}>
			<Box display={'flex'} width={'50%'} height={'100%'} alignItems={'center'}>
				<Stack direction={'column'} width={'100%'} spacing={2}>
					<Typography variant="h5">Validação do endereço de e-mail</Typography>
					{/* Se está tentando validar um token. */}
					{ token ? (
						returnObject ? (
							<Alert severity={returnObject.status} sx={{width:'100%'}}>
								<AlertTitle>{returnObject.title}</AlertTitle>
								{returnObject.message}
							</Alert>
						) : (
							<Loading />
						) 
					) : (
						<Stack direction={'column'} width={'100%'} spacing={2}>
							{ returnObject ? (<Alert severity={returnObject.status}>{returnObject.message}</Alert>) : null }
							<Stack component='form' direction='row' display={'flex'} spacing={1} width={'100%'} justifyContent={'right'} onSubmit={handleFormSubmit} noValidate>
								<TextField 
									type={"email"} 
									name="email"
									label="Digite o seu e-mail de cadastro" 
									value={formState.email.value} 
									onChange={handleFormChange}
									error={formState.email.error}
									helperText={formState.email.error && "Digite um e-mail válido!"}
									required 
									fullWidth
								/>
								<Button type="submit" variant="contained" sx={{width: 200}}>Enviar</Button>
							</Stack>
						</Stack>
					)}
				</Stack>
			</Box>
		</Paper>
	)

}

let formFields = {
	email : {
		error : false,
		value : ''
	}
}

export default Verify